import { UNCOMPLETED_PENDING_DROPS } from 'root/src/shared/descriptions/endpoints/endpointIds';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const uncompletedPendingDropsAlertEndpoint = {
    [UNCOMPLETED_PENDING_DROPS]: {
        cronJobPayloadSchema,
    },
};
